export const VdpTitle = {
  props: ['lang'],
  created() {
  },
  methods: {
    goToCompare(id, lang) {
      lang = this.lang;
      let compare;
      if (!localStorage.compare) {
        var Obj = {
          ids: [id],
        };
        localStorage.setItem('compare', JSON.stringify(Obj));
      } else {
        compare = JSON.parse(localStorage.compare);

        if (compare.ids.indexOf(id) == -1) compare.ids.push(id);

        if (compare.ids.length > 4) {
          compare.ids.splice(0, 1);
        }
        localStorage.compare = JSON.stringify(compare);
      }

      compare = JSON.parse(localStorage.compare);

      var urlIds = [];
      var j = 0;
      for (var i = compare.ids.length - 1; i >= 0; i--) {
        if (j >= 4) break;

        urlIds.push(compare.ids[i]);
        j++;
      }

      var slug = '/compare/';
      if (lang == 'fr-CA')
        slug = '/comparer/'
      window.location.href = slug + '?vehicles=' + urlIds.join('|');
    },
    msieversion() {

      var ua = window.navigator.userAgent;
      var msie = ua.indexOf("MSIE ");
      console.log(msie);
      if (msie > 0 || !!navigator.userAgent.match("rv:11")) // If Internet Explorer, return version number
      {
        return true;
      } else {
        return false;
      }
    },
    getWeeksDiff(startDate, endDate) {
      const msInWeek = 604800;
      var fstartDate = new Date(new Date().toLocaleString('en', { timeZone: 'America/Toronto' })) / 1000;
      
      return Math.ceil((endDate - fstartDate) / msInWeek);
    },
      isMoreThan(value1, value2) {
      return value1 > value2
    },
    isMoreOrEqualThan(value1, value2) {
      return value1 >= value2
    }
  },
 computed: {
  isIe11(){
    return this.msieversion()
  }
 }
};
